<template>
  <div class="content">
    <div class="container-fluid">
      
      <div class="row mb-2">
          <div class="col-md-12">
            
            <div class="nav-bar box-horizontal mb-2">
              <!-- <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i> -->
              <div class="flex-1">
                <h3 class="m-0 text-info"><strong>My Mikrotik</strong></h3>
                <p class="mb-0">Berikut ini daftar Mikroti yang telah anda input</p>
              </div>
            </div>

            <router-link v-show="false" :to="{ name: 'tambah-mikrotik'}"  class="btn btn-primary">Tambah Mikrotik</router-link>
            <router-link :to="{ name: 'mikrotik-monitor'}"  class="btn btn-info">MONITOR MIKROTIK</router-link>
            <router-link :to="{ name: 'mikrotik-monitor-off'}"  class="btn btn-danger">MONITOR PELANGGAN OFFLINE</router-link>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card mt-2">

              <!--

              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="card-title ">List Mikrotik</h4>
                    <p class="card-category">Berikut ini daftar Mikrotiku</p>
                  </div>
                </div>
              </div>

              -->

              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>IP</th>
                      <th>Via</th>
                      <th>Secret</th>
                      <th>Active</th>
                      <th>Non Active</th>
                    <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.Listx" >
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</span> 
                          <button class="btn btn-success btn-sm" @click="mikrotik.login(u.via,u.ip,u.username,u.password,u.nama,index)"><i class="material-icons">login</i></button>
                        </td>
                        <td>{{ u.ip }}</td>
                        <td>
                          <span v-if="u.via == 'ip'">IP Public</span>
                          <span v-else>Tunnel</span>
                        </td>
                        <td class="text-info"><router-link :to="{ name: 'detail-secret', params: { page: 'secret', ip:u.ip, username: u.username, password: u.password, via: u.via }}">{{u.secret}}</router-link>
                        </td>
                        <td class="text-success"><router-link :to="{ name: 'detail-secret', params: { page: 'active', ip:u.ip, username: u.username, password: u.password, via: u.via }}">{{u.active}}</router-link></td>
                        <td class="text-danger"><router-link :to="{ name: 'detail-secret', params: { page: 'nonactive', ip:u.ip, username: u.username, password: u.password, via: u.via }}">{{u.nonactive}}</router-link></td>
                        <td>

                          <button class="btn btn-info btn-sm" @click="mikrotik.getBlogCount(u.via,u.ip,u.username,u.password,u.nama,index)"><i class="material-icons">refresh</i></button>
                          
                          <router-link :to="{ name: 'tambah-mikrotik', params: u }" class="btn btn-sm btn-secondary" @click="data.modalHapus = true,mikrotik.data.idHapus = u.id"><i class="material-icons">edit</i></router-link>

                          <button v-if="RootOnly()" class="btn btn-sm btn-danger" @click="data.modalHapus = true,mikrotik.data.idHapus = u.id"><i class="material-icons">delete_outline</i></button>
                          
                        </td>
                      </tr>
                      
                      <tr v-if="theGet.data.List.length != theGet.data.Listx.length">
                        <td colspan="8" class="text-success">
                          <div class="alert alert-info" role="alert">
                            Sedang mengambil data...
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="8" class="text-success">FYI : Klik Refresh untuk melihat Status Mikrotik anda</td>
                      </tr>

                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
      </div>

			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="data.modalDetail">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Detail Mikrotik</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalDetail = false">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row" v-show="mikrotik.data.loading">
                <div class="col-md-12">
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-center">
                  <label>Daftar Secrets</label>
                  <h3><router-link :to="{ name: 'detail-secret', params: { page: 'secret', ip:mikrotik.data.ip, username: mikrotik.data.username, password: mikrotik.data.password, via: mikrotik.data.via }}">{{mikrotik.data.secret}}</router-link></h3>
                </div>
                <div class="col-md-4 text-center">
                  <label>Active Conn.</label>
                  <h3><router-link :to="{ name: 'detail-secret', params: { page: 'active', ip:mikrotik.data.ip, username: mikrotik.data.username, password: mikrotik.data.password, via: mikrotik.data.via }}">{{mikrotik.data.active}}</router-link></h3>
                </div>
                <div class="col-md-4 text-center">
                  <label>Non Active</label>
                  <h3><router-link :to="{ name: 'detail-secret', params: { page: 'nonactive', ip:mikrotik.data.ip, username: mikrotik.data.username, password: mikrotik.data.password, via: mikrotik.data.via }}">{{mikrotik.data.nonactive}}</router-link></h3>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="data.modalDetail = false">Tutup</button>
            </div>
          </div>
        </div>
      </div>
      
			<!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="data.modalHapus">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Hapus Mikrotik</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalHapus = false">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <p>Hapus Mikrotik?</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="data.modalHapus = false,mikrotik.hapus()">Hapus</button>
              <button type="button" class="btn btn-secondary" @click="data.modalHapus = false">Tutup</button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <transition name="slide-fade" mode="out-in">
    <div class="popup-mikrotik " v-show="mikrotik.data.popup">
        <div class="popup-mikrotik-inner" style="overflow: auto"  v-bind:class="{'top50px' : mikrotik.data.isLogin === true}">

          <div class="login-box pt-3 pb-3" v-show="mikrotik.data.isLogin == false">
            <h3 class=" text-center"> 
              <i class="material-icons">refresh</i> Sedang Login ke Mikrotik...
            </h3>
          </div>

          <div class="col-md-12" v-show="mikrotik.data.isLogin">
            <div class="m-title mt-2 mb-3 box-horizontal">
              <div class="flex-1">
                <h3 class="m-0">Mikrotikku</h3>
                <h4 class="m-0">123.456.789.112</h4>
              </div>
              <div>
                <button class="btn btn-sm btn-gray all-center" @click="mikrotik.data.popup = false, mikrotik.data.isLogin = false"><i class="material-icons">close</i> Tutup</button>
              </div>
            </div>
            <div class="rows">
              <div class="col-md-8">
                <div class="box-horizontal">
                  <div class="col-md-6 text-center">
                    <span class="d-block">CPU</span>
                    <h3 class="m-0">{{mikrotik.data.cpu}}%</h3>
                  </div>
                  <div class="col-md-6">
                    <span class="d-block">{{mikrotik.data.board}}</span>
                    <span class="d-block">Identity : {{mikrotik.data.platform}}</span>
                    <span class="d-block">Router OS : {{mikrotik.data.os}}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="rows">
              <div class="col-md-12">
                <!-- PPOE -->
                <span class="d-block text-warning">Sistem PPOE</span>
                <div class="box-horizontal">
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupSecret}}</h3>
                    <small class="d-block">Jumlah Secret</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupSecretActive}}</h3>
                    <small class="d-block">Active Conn.</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupSecretNon}}</h3>
                    <small class="d-block">Non Active</small>
                  </div>
                </div>

                <!-- STATIC -->
                <span class="d-block text-warning">Sistem IP Binding / Static</span>
                <div class="box-horizontal">
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">-</h3>
                    <small class="d-block">Total Static</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">-</h3>
                    <small class="d-block">Static Aktif</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">-</h3>
                    <small class="d-block">Static NonAktif</small>
                  </div>
                </div>

                <!-- STATIC -->
                <span class="d-block text-warning">Sistem Arp / Queues / Static (Apalah itu namanya, pusing)</span>
                <div class="box-horizontal">
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupQueue}}</h3>
                    <small class="d-block">Total Queue</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupArp}}</h3>
                    <small class="d-block">Total Arp</small>
                  </div>
                  <div class="col-md-4 text-center">
                    <h3 class="d-block m-0">{{mikrotik.data.popupQueueNon}}</h3>
                    <small class="d-block">Queue NonAktif</small>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
    </div>
  </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
  components: { 
    'Loading': Loading
  }, 
  setup() {
    const data = reactive({
      modalDetail: false,
      modalHapus: false,
      proses: 0

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
        List: [],
        Listx: []
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
			  // for filter

        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken')
        }
			
			  var apiUrl = inter.MiktorikList();
        myGlobal.call(datax,apiUrl).then(x => {

          // console

          if (x.status == true) {

            this.data.List = x.data;

            var item = this.data.List[data.proses];
            
            this.data.Listx = x.data;

            //mikrotik.getBlogCount(item.via,item.ip,item.username,item.password,item.nama);

          } else {
            //alert(x.pesan);
          }

        })
      }
    }

    const mikrotik = {
      data: reactive({
        loading: true,
        secret: 0,
        active: 0,
        nonactive: 0,
        idHapus: '',
        ip: '',
        username: '',
        password: '',
        via: '',
        popup: false,
        isLogin: false,
        popupSecret: "-",
        popupSecretActive: "-",
        popupSecretNon: "-",
        popupQueue: "-",
        popupArp: "-",
        popupQueueNon: "-",
        cpu: "-",
        board: "-",
        platform: "-",
        os: "-",
      }),
      login(via,ip,username,password) {
        this.data.popup = true;
        
        setTimeout(function() {
          var datax = {
              ip: ip,
              username:username,
              password:password,
              via:via
          }
        
          var apiUrl = "login.php";
          myGlobal.callMikrotik(datax,apiUrl).then(x => {
            //console.log(JSON.stringify(x));
            if (x.status == true) {
              mikrotik.data.isLogin = true;
              mikrotik.mikrotikGetBeranda(via,ip,username,password);
              mikrotik.mikrotikGetCPU(via,ip,username,password);
            } else {
              alert("Gagal Login");
              mikrotik.data.popup = true;
            }
          })
        }, 2000);

      },
      
      mikrotikGetBeranda(via,ip,username,password) {
        //console.log("get Beranda")
        
        var datax = {
          ip: ip,
          username:username,
          password:password,
          via:via
        }
			
			  var apiUrl = "beranda.php";
        
        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          // console.log(JSON.stringify(x));

          var datae = x.data;
          
          if (x.status == true) {

            mikrotik.data.popupSecret = datae.secret;
            mikrotik.data.popupSecret = datae.secret;
            mikrotik.data.popupSecretActive = datae.active;
            mikrotik.data.popupSecretNon = parseInt(datae.secret) - parseInt(datae.active);

            mikrotik.data.popupQueue = datae.queue;
            mikrotik.data.popupArp = datae.arp;
            mikrotik.data.popupQueueNon = parseInt(datae.queue) - parseInt(datae.arp);

            
          } else {
            
          }


        })
      },
      mikrotikGetCPU(via,ip,username,password) {
        //console.log("get Beranda")
        
        var datax = {
          ip: ip,
          username:username,
          password:password,
          via:via
        }
			
			  var apiUrl = "cpu.php";
        
        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          // console.log(JSON.stringify(x));

          var datae = x.data;
          
          if (x.status == true) {
            
            mikrotik.data.cpu = datae["cpu-load"];
            mikrotik.data.board = datae["board-name"];
            mikrotik.data.platform = datae["platform"];
            mikrotik.data.os = datae["version"];

          } else {
            
          }


        })
      },

      detailx(data) {
        //console.log(JSON.stringify(data));
      },  
      detail(via,ip,username,password) {
        console.log("Get Info Mikrotik");
			  // for filter

        this.data.ip = ip;
        this.data.via = via;
        this.data.username = username;
        this.data.password = password;

        var datax = {
            ip: ip,
            username:username,
            password:password,
            via:via
        }
			
			  var apiUrl = "beranda.php";
        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            var datae = x.data;
            this.data.loading = false;
            this.data.secret = datae.secret;
            this.data.active = datae.active;
            this.data.nonactive = parseInt(datae.secret) - parseInt(datae.active);
          } else {

          }
        })
      },
      hapus() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: this.data.idHapus
        }
			
			  var apiUrl = inter.MiktorikHapus();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            theGet.datae();
          } else {
              //alert(x.pesan);
          }
        })
      },
      secret() {

      },
      getBlogCount(via,ip,username,password,name,index) {

        var datax = {
          ip: ip,
          username:username,
          password:password,
          via:via
        }
			
			  var apiUrl = "beranda.php";
        
        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          let data;
          var datae = x.data;
          
          if (x.status == true) {
            /*
            this.data.loading = false;
            this.data.secret = datae.secret;
            this.data.active = datae.active;
            this.data.nonactive = parseInt(datae.secret) - parseInt(datae.active);

            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: datae.secret,
              active: datae.active,
              nonactive: parseInt(datae.secret) - parseInt(datae.active),
            };
            */
           
            theGet.data.Listx[index]["secret"] = datae.secret;
            theGet.data.Listx[index]["active"] = datae.active;
            theGet.data.Listx[index]["nonactive"] = parseInt(datae.secret) - parseInt(datae.active);
            
          } else {
            /*
            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: 0,
              active: 0,
              nonactive: 0
            };
            */

            theGet.data.Listx[index]["secret"] = 0;
            theGet.data.Listx[index]["active"] = 0;
            theGet.data.Listx[index]["nonactive"] = 0;
          }

          // theGet.data.Listx.push(data);

          theGet.data.Listx[index]["secret"] = datae.secret;
          
          //console.log(theGet.data.Listx[index]["secret"]);

          let datawoy = theGet.data.Listx;

          theGet.data.Listx = [];

          theGet.data.Listx = datawoy;

          // console.log("hola "+ JSON.stringify(theGet.data.Listx));

          //return data;

        })

        data.proses++;

        if (data.proses < theGet.data.List.length) {
          var item = theGet.data.List[data.proses];
          //console.log(JSON.stringify(item));

          // mikrotik.getBlogCount(item.via,item.ip,item.username,item.password,item.nama);
        }
        
      }
    } // 
    return {
      data, 
      theGet,
      mikrotik
    }
  },
  mounted () {
    document.title = "List Mikrotik";

    this.theGet.datae();

    
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.popup-mikrotik {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(
    0,0,0,0.5);
  z-index: 9999;
}
.popup-mikrotik-inner {
  animation: 0.2;
  position: fixed;
  left: 20%;
  right: 20%;
  bottom: 0;
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  z-index: 9999;
}
@media only screen and (max-width: 600px) {
  .popup-mikrotik-inner {
    left: 0;
    right: 0;
  }
}
.top50px {
  top:50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mikrotik/main.vue